import React, {Fragment} from 'react';
import classNames from "classnames";
import config from "../../config/config";
import isEqual from "lodash-es/isEqual";
import PropTypes from "prop-types";
import {sendRequest} from "../../utils/request";
import axios from "axios";
import RadioBox from "./RadioBox";

class RadioGroup extends React.Component {

    static propTypes = {
        saveChanges: PropTypes.func,
        onSelect: PropTypes.func,
        valueKey: PropTypes.string,
        labelKey: PropTypes.string,
        component: PropTypes.string,
        optionname: PropTypes.string,
        optioncomponent: PropTypes.string,
        isLoading: PropTypes.bool,
        minLength: PropTypes.number,
        options: PropTypes.array,
        boundValue: PropTypes.any,
        boundField: PropTypes.any,
        filter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        value: PropTypes.any,
        label: PropTypes.any,
        required: PropTypes.bool,
        disabled: PropTypes.any,
        error: PropTypes.any,
        name: PropTypes.string,
        autoSelect: PropTypes.bool,
        objectValue: PropTypes.bool
    };

    state = {
        isLoading: false,
        options: []
    };

    constructor(props){
        super(props);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const current = this.generateQueryParams(this.props, this.state);
        const prev = this.generateQueryParams(prevProps, prevState);
        if (!isEqual(current, prev)) {
            this.setState({
                options: [],
                isLoading: true,
            }, () => this.loadOptions());
        }
    }

    componentDidMount() {
        this.loadOptions();
    }

    generateQueryParams = (props, state) => {
        const listparams = {
            option: "componentlist",
            component: props.component || "option",
            itemsperpage: 0
        };
        if (props.optioncomponent) {
            listparams.optioncomponent = props.optioncomponent;
        }
        if (props.storeType === "bound" && props.boundValue) {
            if (props.boundValue) {
                listparams.filter = [{field: props.boundField, value: props.boundValue}];
            }
        }
        if (!props.component) listparams.optionname = props.optionname;
        let filter = listparams.filter;
        if (filter && !Array.isArray(filter)) filter = [filter];
        if (props.filter) {
            filter = [...(filter || []), ...(Array.isArray(props.filter) ? props.filter : [props.filter])];
        }
        if (filter) {
            listparams.filter = filter;
        } else {
            delete listparams.filter;
        }
        return listparams;
    }

    loadOptions = async () => {
        this.lastrequest && this.lastrequest.abort();
        this.setState({isLoading: true}, () => {
            if (!this.props.options) {
                const reqparams = this.generateQueryParams(this.props, this.state);
                if (!reqparams) {
                    this.setState({isLoading: false});
                    return;
                }
                this.lastrequest = sendRequest(reqparams);
                this.lastrequest.then((data) => {
                    this.setState({isLoading: false, options: data.items || []}, () => {
                        if (data.items.length === 1 && this.props.autoSelect) {
                            this.handleChange(data.items[0]);
                        }
                    });
                }).catch((e) => {
                    if (!(e instanceof axios.Cancel) && e.message) {
                        console.log(e);
                        this.setState({isLoading: false});
                    }
                });
            } else {
                this.setState({isLoading: false});
            }
        });
    }

    saveChanges = (field, value) => {
        if (this.props.saveChanges) {
            this.props.saveChanges(field, !this.props.objectValue && value instanceof Object ? value[this.props.valueKey || "id"] : value);
        }
    }

    render() {
        const value = this.props.value instanceof Object ? this.props.value[this.props.valueKey || "id"] : this.props.value;
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        const options = (this.props.options || this.state.options);
        return <div className={"radiogroup"}>
            <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
            {options.map((option, idx) => {
                const optionValue = option instanceof Object ? option[this.props.valueKey || "id"] : option;
                return <RadioBox
                    key={idx}
                    name={this.props.name}
                    value={option}
                    disabled={this.props.disabled}
                    checked={value == optionValue}
                    label={option[this.props.labelKey || "name"]}
                    saveChanges={this.saveChanges}
                />
            })}
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </div>;
    }
}

export default RadioGroup;